var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ width: '100%' })},[(_vm.specialSpacer)?_c('spacer-special',{attrs:{"characterBlock":_vm.text}}):_c('div',{style:({ textAlign: _vm.textAlign })},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }